__turbopack_context__.v({
  "shape": "m5RkRW_shape",
  "shapesContainer": "m5RkRW_shapesContainer",
  "wrapper": "m5RkRW_wrapper",
});
